import React from "react";

import styles from "./sticky-footer.module.scss";

const StickyFooter = (props: React.PropsWithChildren<{}>) => {
  return <footer className={styles.footer}>{props.children}</footer>;
};

export { StickyFooter };
